<template>
  <div class="form__group" v-show="childFields.length > 0">
    <div class="form__field" v-show="field.title">
      <div class="form__title">{{ field.title }}</div>
    </div>
    <div class="form__breaker" v-show="field.title"></div>
    <component :field="field" :is="'checkout-field-hidden'"></component>
    <component
      v-for="childField in childFields"
      :key="childField.name"
      :field="childField"
      :is="'checkout-field-' + childField.type"
    >
    </component>
    <div class="form__message form__message--error" v-show="field.error">
      {{ field.error }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-group",
  computed: {
    childFields: function() {
      return this.field.fields.filter(field => !field.disabled);
    }
  },
  mounted() {
    let updateField = () => {
      let values = this.childFields
        .filter(childField => childField.value)
        .map(childField => childField.value);

      if (this.field.excludes) {
        let excludes = this.field.excludes.map(exclude =>
          exclude.filter(excludeValue => !values.includes(excludeValue))
        );

        let disabledValues = excludes
          .filter(exclude => exclude.length === 1)
          .flat();

        this.field.fields.forEach(field => {
          if (!field.options) return;

          this.$store.dispatch("updateField", {
            field: field,
            newProps: {
              options: field.options.map(option => {
                return {
                  ...option,
                  disabled: disabledValues.includes(option.value)
                };
              })
            }
          });
        });
      }

      this.$store.dispatch("updateField", {
        field: this.field,
        newProps: {
          value: values.join(".")
        }
      });
    };

    this.$store.subscribe((mutation, state) => {
      if (mutation.type !== "updateField") return;
      if (!mutation.payload.newProps.value) return;
      if (!this.childFields.includes(mutation.payload.field)) return;

      updateField();
    });

    updateField();
  }
};
</script>
